module.exports = __webpack_public_path__ + "img/favicon-cv-semplice.5be2b310.svg";